import { extractPlantId } from "../utils/Utils";
import {
  deleteRequest,
  getRequest,
  getRequestWithAuthorization,
  postRequest,
  putRequest,
} from "./api";
import { API_URLS } from "./appUrls";

const getBaseURL = () => `${API_URLS.plants}/${extractPlantId()}`;

export const getToken = (header, i18n) =>
  getRequestWithAuthorization(`${API_URLS.token}`, header, i18n);

export const uploadSelectedFile = (
  fileData,
  fileName,
  chunkIndex,
  totalChunks,
  commitBlockList,
) =>
  postRequest(
    `${getBaseURL()}/uploadfile?file_name=${fileName}&chunkIndex=${chunkIndex}&totalChunks=${totalChunks}&commit_block_list=${commitBlockList}`,
    fileData,
  );

export const getSegments = () =>
  getRequest(`${getBaseURL()}/${API_URLS.segments}`);

export const createSegments = () =>
  postRequest(`${getBaseURL()}/${API_URLS.segments}`);

export const proceedAnalyticsStatus = () =>
  getRequest(`${getBaseURL()}/${API_URLS.analysisStatus}`);

export const getLastFileDetails = () =>
  getRequest(`${getBaseURL()}/${API_URLS.details}`);

export const updatePlantInformation = (payload) =>
  putRequest(`${getBaseURL()}/${API_URLS.plantDetails}`, payload);

export const getCIPs = () => getRequest(`${getBaseURL()}/${API_URLS.cips}`);

export const getIdentifiedCIPs = () =>
  getRequest(`ca/${getBaseURL()}/${API_URLS.cips}`);

export const uploadCips = (payload) =>
  postRequest(`${getBaseURL()}/${API_URLS.uploadCips}`, payload);

export const uploadBulkCIPs = (selectedTrain, payload) => {
  return postRequest(
    `${getBaseURL()}/${API_URLS.cips}/${API_URLS.bulk}?train_num=${selectedTrain}`,
    payload,
  );
};

export const editCip = (cipId, payload) =>
  putRequest(`${getBaseURL()}/${API_URLS.uploadCips}/${cipId}`, payload);

export const deleteCip = (cipId) =>
  deleteRequest(`${getBaseURL()}/${API_URLS.uploadCips}/${cipId}`);

export const cleaningEffectivness = () =>
  getRequest(`${getBaseURL()}/${API_URLS.executeCleaning}?recalculate=true`);

export const cleaningEffectivnessStatus = (task_id) =>
  getRequest(
    `${getBaseURL()}/${API_URLS.executeCleaningStatus}?run_id=${task_id}`,
  );

export const cleanedData = () =>
  getRequest(`${getBaseURL()}/${API_URLS.cleanedData}`);

export const getFoulingInformation = () =>
  getRequest(`${getBaseURL()}/${API_URLS.fouling}`);

export const getPredictLimits = () => getRequest(`${getBaseURL()}/limits`);

export const predictionCalculation = (window) =>
  getRequest(
    `${getBaseURL()}/prediction/calculation?forecast_window=${window}`,
  );

export const getPredictionData = (window) =>
  getRequest(`${getBaseURL()}/prediction?forecast_window=${window}`);

export const getPredictionStatus = (task_id) =>
  getRequest(`${getBaseURL()}/prediction/status?run_id=${task_id}`);

export const getHeaders = () =>
  getRequest(`${getBaseURL()}/${API_URLS.header}`);

export const getfoulingType = () =>
  getRequest(`${getBaseURL()}/${API_URLS.foulingType}`);

export const getAnalysisJob = (forecast_window) =>
  getRequest(
    `${getBaseURL()}/${API_URLS.analysisjob}?forecast_window=${forecast_window}`,
  );

export const getAnalysisStatus = (task_id) =>
  getRequest(`${getBaseURL()}/${API_URLS.analysisStatus}?run_id=${task_id}`);

export const getAnalysis = () =>
  getRequest(`${getBaseURL()}/${API_URLS.analysis}`);

export const getType = () => getRequest(`${getBaseURL()}/${API_URLS.type}`);

export const getPlants = () => getRequest(`${API_URLS.plants}`);

export const getPlantDetails = (includeFile = false) =>
  getRequest(`${getBaseURL()}?includeFile=${includeFile}`);

export const getWaterQualityDefaults = (waterType) =>
  getRequest(
    `${API_URLS.plants}/${API_URLS.waterQualityDefaults}?water_type=${encodeURIComponent(
      waterType,
    )}`,
  );

export const deletePlants = () => deleteRequest(`${getBaseURL()}`);

export const savePlant = (payload) =>
  postRequest(`${API_URLS.plants}`, payload);

export const saveUser = (payload) => postRequest(`${API_URLS.user}`, payload);
export const editPlant = (payload) => putRequest(`${getBaseURL()}`, payload);

export const getColumnMapping = (fileId) =>
  getRequest(`${getBaseURL()}/${API_URLS.cols}/${fileId}`);

export const updateColumnMapping = (fileId, payload) =>
  putRequest(`${getBaseURL()}/${API_URLS.colmapping}/${fileId}`, payload);

export const confirmRefrenceCondition = (fileId, payload) =>
  putRequest(`${getBaseURL()}/${API_URLS.refcondition}/${fileId}`, payload);

export const getDataVisualization = (fileId) =>
  getRequest(`${getBaseURL()}/files/${fileId}/${API_URLS.visualization}`);

export const setadvanceSettings = (payload) =>
  putRequest(`${getBaseURL()}/${API_URLS.advancesettings}`, payload);

export const getadvanceSettings = () =>
  getRequest(`${getBaseURL()}/${API_URLS.advancesettings}`);

export const updatedCleanings = (payload) =>
  putRequest(`${getBaseURL()}/${API_URLS.cleaninganalysis}`, payload);

export const getProceedToAnalysis = (fileId) =>
  getRequest(`${getBaseURL()}/files/${fileId}/${API_URLS.proceedToAnalysis}`);

export const setState = (state) =>
  putRequest(`${getBaseURL()}/${API_URLS.state}?state=${state}`);

export const acceptTC = () => postRequest(`${API_URLS.acceptTC}`);

export const sharePlant = (plant_id, payload) =>
  postRequest(`${API_URLS.plants}/${plant_id}/${API_URLS.share}`, payload);

export const unsharePlant = (plant_id, email) =>
  deleteRequest(
    `${API_URLS.plants}/${plant_id}/${API_URLS.share}?shared_email=${email}`,
  );

export const getUsers = (plant_id) =>
  getRequest(`${API_URLS.plants}/${plant_id}/${API_URLS.users}`);

export const accessRequest = (payload) =>
  postRequest(`${API_URLS.user}/${API_URLS.accessRequest}`, payload);

export const getAccessRequest = (
  page = 1,
  pageSize = 5,
  filters,
  sortField,
  sortOrder,
) => {
  const offset = (page - 1) * pageSize;
  const params = new URLSearchParams({
    sort_by: sortField,
    order: sortOrder,
    limit: pageSize,
    offset,
  });

  if (filters && filters.length > 0) {
    filters.forEach((f) => params.append("filters", f));
  }

  const url = `${API_URLS.admin}/${
    API_URLS.accessRequests
  }?${params.toString()}`;
  return getRequest(url);
};

export const updateRequests = (payload) =>
  putRequest(`${API_URLS.admin}/${API_URLS.accessRequest}`, payload);

export const exportExcel = (type) => {
  const url = `${API_URLS.admin}/${
    API_URLS.exportExcel
  }?type=${encodeURIComponent(type)}`;
  // Request as blob for Excel download
  return getRequest(url, { responseType: "blob" });
};
